module.exports = __webpack_public_path__ + "static/media/select_level_dropdown_arrow.d5d53aa9.svg";